import React from 'react';

export default function FanshopComponent() {
    return (
        <div>
            <a style={{fontFamily: "Franklin Gothic Medium", color: "black"}} href="https://sv-sendelbach-steinbach.fan12.de/" target='_blank'>HIER KLICKEN</a> und mit Fanausrüstung eindecken!
        </div>
    )
}
